import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  LoginEmailRequest1l3a375d4eoce as LoginEmailRequest,
  Flavor_HomeownerRegistration_getInstance259ch7dnofaj1 as Flavor_HomeownerRegistration_getInstance,
  RegisterUser77vi01gsji2g as RegisterUser,
  Addresscpovxna1tjmg as Address,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_selectedApi2skzkr2pn0lot as get_selectedApi } from '../../../sdk/apiOptions.mjs';
import {
  awaitqeg6zusi9ora as await_0,
  await1kke5zj2piplv as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/LsErrorException.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_sessionToken1e5yonv6d457l as get_sessionToken } from '../../../sdk/UserSession.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { LandingScreennv9edtrim3be as LandingScreen } from '../common/LandingScreen.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Proof19kcc739cbo52 as Proof } from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/auth/proof/proofModels.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { AuthDialogSemantic_getInstancetw8ua0jubs3m as AuthDialogSemantic_getInstance } from '../../theming/appTheme.mjs';
import {
  authFrameoft44vbj3f9u as authFrame,
  authCol17erwkvgugxzv as authCol,
} from './handleAuthRendering.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  _EmailAddress___init__impl__a6ugvr3vyholn0wwoi2 as _EmailAddress___init__impl__a6ugvr,
  _PhoneNumber___init__impl__slwhzyo93bblbw66x0 as _PhoneNumber___init__impl__slwhzy,
  _EmailAddress___get_raw__impl__6ose21hsaqj8b5ou10 as _EmailAddress___get_raw__impl__6ose2,
} from '../../../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { UserRole_Customer_getInstance1i1qwr4axl8qb as UserRole_Customer_getInstance } from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { User8yb1tqk4kykg as User } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { Draft43syxm8fng0j as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  Companion_getInstance33aui7uk8ap15 as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { UserForm7kih3xavfx72 as UserForm } from '../client/UserForm.mjs';
import { get_AutoRoutes3nqqi7p59slz8 as get_AutoRoutes } from '../../autoroutes.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { ImageViewadm9fg4ms58f as ImageView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ImageView.mjs';
import { Resources_getInstance2tvlmekcueurd as Resources_getInstance } from '../../../Resources.js.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  smallBody2trfy14zwtona as smallBody,
} from '../../theming/Titles.mjs';
import { Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { EmailProof3rgt8vdvz5buo as EmailProof } from './EmailProof.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Paire9pteg33gng7 as Pair } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { AuthScreen1ogng2fnfjgd9 as AuthScreen } from './LogInScreen.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.dj1_1.det_1.tj0_1.zaj($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var newUser = tmp;
  var tmp_0 = $this.dj1_1.ej1().bfx().bfh_1.gfs(LoginEmailRequest().a9y(newUser, Flavor_HomeownerRegistration_getInstance()), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  $this.dj1_1.cet_1.mam(tmp_0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_selectedApi();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.bfx().bfh_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.fj1_1.det_1.tj0_1;
  var tmp_1 = await_1(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = tmp_0.gfs(LoginEmailRequest().a9y(tmp$ret$1, Flavor_HomeownerRegistration_getInstance()), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return tmp_2;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.gj1_1.cet_1.gah(null, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, proof, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_selectedApi();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var api = tmp.bfx();
  try {
    var tmp_0 = api.bfh_1.hfs(new (RegisterUser())($this.hj1_1, proof), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof LsErrorException()) {
      var e = $p;
      if (!(e.udr_1.r4b_1 === 'already-registered'))
        throw e;
    } else {
      throw $p;
    }
  }
  var tmp_1 = api.bfh_1.sei(listOf(proof), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var session = tmp_1;
  var tmp_2 = get_sessionToken().gah(ensureNotNull(session.n4k_1), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = get_mainPageNavigator($this.ij1_1);
  var tmp0_elvis_lhs = $this.jj1_1.yes_1;
  tmp_3.ebw(tmp0_elvis_lhs == null ? new (LandingScreen())() : tmp0_elvis_lhs);
  return Unit_instance;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var UserRegistration$dataEntry$slambdaClass;
function UserRegistration$dataEntry$slambda() {
  if (UserRegistration$dataEntry$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.dj1_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UserRegistration$dataEntry$slambdaClass = $;
  }
  return UserRegistration$dataEntry$slambdaClass;
}
function UserRegistration$dataEntry$slambda_0(this$0) {
  var i = new (UserRegistration$dataEntry$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var UserRegistration$confirmation$slambdaClass;
function UserRegistration$confirmation$slambda() {
  if (UserRegistration$confirmation$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.fj1_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UserRegistration$confirmation$slambdaClass = $;
  }
  return UserRegistration$confirmation$slambdaClass;
}
function UserRegistration$confirmation$slambda_0(this$0) {
  var i = new (UserRegistration$confirmation$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var UserRegistration$confirmation$slambdaClass_0;
function UserRegistration$confirmation$slambda_1() {
  if (UserRegistration$confirmation$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.gj1_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UserRegistration$confirmation$slambdaClass_0 = $;
  }
  return UserRegistration$confirmation$slambdaClass_0;
}
function UserRegistration$confirmation$slambda_2(this$0) {
  var i = new (UserRegistration$confirmation$slambda_1())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var UserRegistration$confirmation$slambdaClass_1;
function UserRegistration$confirmation$slambda_3() {
  if (UserRegistration$confirmation$slambdaClass_1 === VOID) {
    class $ {
      constructor($data, $this_confirmation, this$0) {
        this.hj1_1 = $data;
        this.ij1_1 = $this_confirmation;
        this.jj1_1 = this$0;
      }
      viq(proof, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, proof), $completion);
      }
      s2(p1, $completion) {
        return this.viq(p1 instanceof Proof() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UserRegistration$confirmation$slambdaClass_1 = $;
  }
  return UserRegistration$confirmation$slambdaClass_1;
}
function UserRegistration$confirmation$slambda_4($data, $this_confirmation, this$0) {
  var i = new (UserRegistration$confirmation$slambda_3())($data, $this_confirmation, this$0);
  var l = (proof, $completion) => i.viq(proof, $completion);
  l.$arity = 1;
  return l;
}
function UserRegistration$render$lambda$lambda($next, this$0) {
  return ($this$swap) => {
    var pair = $next;
    var tmp;
    if (pair == null) {
      var tmp_0 = get_scrolling($this$swap);
      tmp = $this$swap.jbb(tmp_0, authCol($this$swap, ($this$authCol) => {
        $this$authCol.jbb(sizeConstraints($this$authCol, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1), this$0.lj1($this$authCol));
        return Unit_instance;
      }));
    } else {
      var tmp_1 = get_scrolling($this$swap);
      tmp = $this$swap.jbb(tmp_1, authFrame($this$swap, ($this$authFrame) => {
        $this$authFrame.jbb($this$authFrame.ibb(get_centered($this$authFrame), $this$authFrame.hbb(AuthDialogSemantic_getInstance())), this$0.kj1($this$authFrame, pair.af_1, pair.bf_1));
        return Unit_instance;
      }));
    }
    return tmp;
  };
}
var UserRegistrationClass;
function UserRegistration() {
  if (UserRegistrationClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        tmp.wes_1 = remember(VOID, VOID, VOID, ($this$remember) => this.mj1().u9w_1.d7b_1);
        this.xes_1 = Signal().fak(null);
        this.yes_1 = null;
        this.bet_1 = validated(Draft(new (User())(VOID, _EmailAddress___init__impl__a6ugvr(''), _PhoneNumber___init__impl__slwhzy(''), VOID, '', '', new (Address())(), VOID, VOID, UserRole_Customer_getInstance())));
        this.cet_1 = Signal().fak(null);
        this.det_1 = new (UserForm())(this.bet_1, true, get_rem(40));
      }
      ucv() {
        return this.wes_1;
      }
      dir(value) {
        this.yes_1 = value;
        var tmp;
        if (value == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver = get_AutoRoutes().nbw(value);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.obw_1;
          tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.sbw();
        }
        this.xes_1.mam(tmp);
      }
      mj1() {
        var tmp = this.zes_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('projectData');
        }
      }
      ej1() {
        var tmp = this.aet_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('apiOption');
        }
      }
      lj1(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        var tmp0_height = get_rem(4);
        var tmp1_width = get_rem_0(19.135);
        var tmp = view_0.ibb(sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, tmp1_width, tmp0_height), get_centered(view_0));
        // Inline function 'com.lightningkite.kiteui.views.direct.image' call
        // Inline function 'kotlin.apply' call
        var this_0 = new (ImageView())(view_0);
        this_0.oda(Resources_getInstance().vf8_1);
        this_0.zba();
        view_0.jbb(tmp, this_0);
        var tmp_0 = get_centered(view_0);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
        view_1.bbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = 'Welcome to Stoze, your escrow solution. You need to create a user before you can accept the project.';
        var tmp_1 = view_1.tb5_1;
        var tmp_2;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_2 = '\xA0';
        } else {
          tmp_2 = value;
        }
        tmp_1.fbu(tmp_2);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_0, view_1);
        render(this.det_1, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Space())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.ebb(p_2, view_2);
        view_0.fbb(p_2, view_2);
        var tmp_3 = view_0.ibb(view_0.ibb(get_centered(view_0), sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_rem(25))), get_primaryButton(view_0));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view_0.pc());
        var tmp0_elvis_lhs_3 = view_0.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
        view_0.ebb(p_3, view_3);
        var tmp_4 = KMutableProperty0();
        var tmp_5 = Button$_get_enabled_$ref_61t7nx(view_3);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('enabled', 0, tmp_4, tmp_5, Button$_set_enabled_$ref_o8kynz(view_3));
        reactiveScope(view_3, ($this$reactiveScope) => {
          var tmp$ret$14 = $this$reactiveScope.baj(get_issues(this.bet_1)).i1();
          this_1.set(tmp$ret$14);
          return Unit_instance;
        });
        specCenteredText(view_3, 'Register');
        onClick(view_3, VOID, VOID, UserRegistration$dataEntry$slambda_0(this));
        view_0.fbb(p_3, view_3);
        view_0.jbb(tmp_3, view_3);
        view_0.jbb(get_centered(view_0), smallBody(view_0, 'You will be signed in after registering'));
        view.fbb(p_0, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
      kj1(_this__u8e3s4, token, data) {
        var tmp = UserRegistration$confirmation$slambda_0(this);
        var tmp_0 = ($this$EmailProof) => _EmailAddress___get_raw__impl__6ose2(data.g88_1);
        var tmp_1 = UserRegistration$confirmation$slambda_2(this);
        return render(EmailProof().lip(token, tmp, tmp_0, tmp_1, UserRegistration$confirmation$slambda_4(data, _this__u8e3s4, this)), _this__u8e3s4);
      }
      ud6(_this__u8e3s4) {
        try {
          this.mj1();
          this.ej1();
        } catch ($p) {
          if ($p instanceof Exception()) {
            var e = $p;
            get_mainPageNavigator(_this__u8e3s4).ebw(new (LandingScreen())());
            // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (Frame())(_this__u8e3s4.pc());
            var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
            var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
            _this__u8e3s4.ebb(p, view);
            _this__u8e3s4.fbb(p, view);
            return view;
          } else {
            throw $p;
          }
        }
        var tmp = get_unpadded(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (SwapView())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs_0 = _this__u8e3s4.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? _this__u8e3s4 : tmp0_elvis_lhs_0;
        _this__u8e3s4.ebb(p_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_0 = view_0;
        var queue = ArrayList().w();
        var alreadySwapping = {_v: false};
        reactiveScope(this_0, ($this$reactiveScope) => {
          var t = $this$reactiveScope.baj(this.cet_1);
          var c = t == null ? null : new (Pair())(t, $this$reactiveScope.baj(this.bet_1));
          queue.v(c);
          var tmp;
          if (alreadySwapping._v) {
            return Unit_instance;
          }
          alreadySwapping._v = true;
          $l$loop: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue.i1()) {
              break $l$loop;
            }
            var next = queue.z3(0);
            try {
              var tmp_0 = Companion_getInstance().xax_1;
              this_0.rci(tmp_0, UserRegistration$render$lambda$lambda(next, this));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().vd('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping._v = false;
          return Unit_instance;
        });
        _this__u8e3s4.fbb(p_0, view_0);
        return _this__u8e3s4.jbb(tmp, view_0);
      }
    }
    initMetadataForClass($, 'UserRegistration', UserRegistration, VOID, [Page(), AuthScreen()]);
    UserRegistrationClass = $;
  }
  return UserRegistrationClass;
}
//region block: exports
export {
  UserRegistration as UserRegistration2mhykjk2xa45,
};
//endregion

//# sourceMappingURL=UserRegistration.mjs.map
